// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useState, useEffect, Fragment } from "react";
import styled from "styled-components";
import { Button, Card, Divider } from "antd";

import { PhotosUploader } from "src/components/fileUploader/photosUploader";
import { areArraysEqual } from "src/utils/arrays";
import {
  getFacilityPhotos,
  writeReferenceToFacilityImage,
  uploadFacilityImage,
} from "src/containers/accountManagement/facilityPhotos/api";
import { readAndCompressImage } from "browser-image-resizer";
import { RestrictedSignedProfile } from "src/components/RestrictedSignedProfile/RestrictedSignedProfile";
import { showErrorToast } from "@src/appV2/lib/Notifications";

const FacilityPhotosCard = styled(Card)`
  .ant-card-body {
    padding: 12px;
    p {
      margin: 0;
    }
  }
  .ant-upload-list-item-thumbnail {
    padding-top: 12.5%;
    padding-bottom: 12.5%;
  }
`;

const compressImageConfig = {
  quality: 0.5,
  maxWidth: 1200,
  autoRotate: false,
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'filteredNewPhotos' implicitly has an 'any' type.
const compressImages = async (filteredNewPhotos) => {
  await Promise.all(
    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'photo' implicitly has an 'any' type.
    filteredNewPhotos.map(async (photo) => {
      const resizedImage = await readAndCompressImage(photo.originFileObj, compressImageConfig);
      photo.originFileObj = resizedImage;

      return photo;
    })
  );
};

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'newPhotosList' implicitly has an 'any' type.
const mapPhotosBeforePost = ({ newPhotosList, filteredNewPhotos, fileUploadResult }) => {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dataBeforePost: any[] = [];
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'nPh' implicitly has an 'any' type.
  filteredNewPhotos.forEach((nPh, idx) => {
    if (fileUploadResult[idx]) {
      nPh.fileStorageFileKey = fileUploadResult[idx].fileStorageFileKey;
      nPh.fileStorageRootFolder = fileUploadResult[idx].fileStorageRootFolder;
    }
  });
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'np' implicitly has an 'any' type.
  newPhotosList.forEach((np) => {
    dataBeforePost.push({
      facilityId: np.facilityId,
      index: np.index,
      name: np.name,
      fileStorageFileKey: np.fileStorageFileKey,
      fileStorageRootFolder: np.fileStorageRootFolder,
    });
  });

  return dataBeforePost;
};

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'facility' implicitly has an 'any' type.
export function FacilityPhotos({ facility, readOnly = false }) {
  const fileName = facility.name;
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [photosList, setPhotosList] = useState<any[]>([]);
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [newPhotosList, setNewPhotosList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isShowSaveButton, setIsShowSaveButton] = useState(false);
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [filesToDelete, setFilesToDelete] = useState<any[]>([]);

  const getPhotos = () => {
    setIsLoading(true);
    getFacilityPhotos({
      facilityId: facility.userId,
    })
      .then((data) => {
        setPhotosList(data);
        setNewPhotosList(data);
        setIsLoading(false);
      })
      // FIXME: Automatically disabled during ESLint config update
      // @ts-expect-error TODO(typecheck-unify): TS6133 'error' is declared but its value is never read.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((error) => {
        showErrorToast("Failed to get getPhotos ");
      });
  };

  useEffect(() => {
    getPhotos();
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'nPl' implicitly has an 'any' type.
  const onPhotosChanged = (nPl) => {
    if (!areArraysEqual(photosList, nPl)) {
      setIsShowSaveButton(true);
      setNewPhotosList(nPl);
    }
  };

  const onSave = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    newPhotosList.forEach((ph, idx) => {
      ph.facilityId = facility.userId;
      ph.index = `${idx}`;
      ph.name = `${fileName}-${idx}`;
    });

    const filteredNewPhotos = newPhotosList.filter((ph) => ph.originFileObj !== undefined);

    try {
      await compressImages(filteredNewPhotos);
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    } catch (error: any) {
      showErrorToast("Failed to compress images");
      setIsLoading(false);
      return;
    }

    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let fileUploadResult: any[] = [];
    try {
      fileUploadResult = await uploadFacilityImage(facility?.userId, filteredNewPhotos);
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    } catch (error: any) {
      showErrorToast("failed to upload images");
      setIsLoading(false);
      return;
    }

    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let updatedReference: any = [];
    try {
      updatedReference = mapPhotosBeforePost({
        newPhotosList,
        filteredNewPhotos,
        fileUploadResult,
      });
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    } catch (error: any) {
      showErrorToast("failed to upload images");
      setIsLoading(false);
      return;
    }

    try {
      await writeReferenceToFacilityImage({
        facilityId: facility.userId,
        updatedReference,
        filesToDelete,
      });
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    } catch (error: any) {
      showErrorToast("failed to write reference to FacilityImages");
      setIsLoading(false);
      return;
    }

    setIsShowSaveButton(false);
    setFilesToDelete([]);
    getPhotos();
  };

  const onCancel = () => {
    setNewPhotosList(photosList);
    setIsShowSaveButton(false);
    setFilesToDelete([]);
  };

  function Actions() {
    if (isShowSaveButton) {
      return (
        <Fragment>
          <Button onClick={onCancel}>Cancel</Button>
          <Divider type="vertical" />
          <RestrictedSignedProfile
            /* @ts-expect-error FIXME this wrong type */
            action="upload photos"
            page="Facility Information"
          >
            <Button type="primary" onClick={onSave}>
              Save
            </Button>
          </RestrictedSignedProfile>
        </Fragment>
      );
    }
    return <Fragment />;
  }

  return (
    <FacilityPhotosCard style={{ borderRadius: 8 }} title="Photos" extra={<Actions />}>
      <PhotosUploader
        fileName={fileName}
        isLoading={isLoading}
        fileList={newPhotosList}
        setFileList={setNewPhotosList}
        onPhotosChanged={onPhotosChanged}
        filesToDelete={filesToDelete}
        setFilesToDelete={setFilesToDelete}
        readOnly={readOnly}
      />
    </FacilityPhotosCard>
  );
}
